import ElTabs from './src/tabs'

export default ElTabs



// WEBPACK FOOTER //
// ./src/public/components/el-tabs/index.js